import {
  aCreateAggregationRule,
  mockCreateAggregationRuleBuilderOperationMutation,
} from '__generated__';
import { ruleBuilderQuery_aggregation } from 'mocks/queries/RuleBuilderQueryOperation.mocks';
import { delay, HttpResponse } from 'msw';

export const createAggregationRuleResponse = {
  __typename: 'Mutation' as const,
  createAggregationRule: aCreateAggregationRule({
    data: {
      ...ruleBuilderQuery_aggregation.rule,
    },
  }),
};

export const handlers = [
  mockCreateAggregationRuleBuilderOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        // @ts-expect-error windowSizeInMillisecnds is aliased which causes issues with typing since MSW doesn't handle this case
        data: createAggregationRuleResponse,
      });
    }
  ),
];
